import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { VideoModal, VideoPlayer } from '../../../sharedComponents';
import {
  TopPosition,
  BottomPosition,
  LeftPosition,
  RightPosition,
} from './displayStyles';
import { Wrapper } from './index.style';
import {
  VideoLinkPosition,
  VideoModulePositions,
  VideoModuleType,
} from '../../types';

export interface VideoModuleProps
  extends Pick<
    VideoModuleType,
    | 'videoId'
    | 'videoPosition'
    | 'videoSource'
    | 'title'
    | 'titleSize'
    | 'text'
    | 'link'
    | 'streamlyUrl'
  > {}

export interface StandardDisplayProps extends VideoModuleProps {
  thumbnail: string;
  modalOpened: boolean;
  standardVideoWidth: boolean;
  videoPlay: boolean;
  toggleModal: () => void;
  poster?: string;
  linkPosition: VideoLinkPosition;
  style: string;
  moduleType: string;
}

export const StandardDisplay = (props: StandardDisplayProps) => {
  const themeConfig = useContext(ThemeContext);
  const {
    videoId,
    videoSource,
    videoPosition,
    poster,
    title,
    titleSize,
    text,
    link,
    thumbnail,
    modalOpened,
    toggleModal,
    streamlyUrl,
    standardVideoWidth,
    videoPlay,
    linkPosition,
    style,
    moduleType,
  } = props;

  const PlayerComponent = (
    <VideoPlayer
      source={videoSource}
      id={videoId}
      title={title}
      streamlyUrl={streamlyUrl}
    />
  );

  /* istanbul ignore next */
  const linkMode =
    themeConfig.name === 'FanExpo'
      ? style === 'PRIMARY' || style === 'ACCENT'
        ? 'white'
        : 'black'
      : undefined;

  return (
    <Wrapper>
      {videoPosition === VideoModulePositions.TOP && (
        <TopPosition
          thumbnail={thumbnail}
          poster={poster}
          title={title}
          titleSize={titleSize}
          text={text}
          link={link}
          linkMode={linkMode}
          toggleModal={toggleModal}
          standardVideoWidth={standardVideoWidth}
          videoPlay={videoPlay}
          playerComponent={PlayerComponent}
          moduleType={moduleType}
        />
      )}
      {videoPosition === VideoModulePositions.BOTTOM && (
        <BottomPosition
          thumbnail={thumbnail}
          poster={poster}
          title={title}
          titleSize={titleSize}
          text={text}
          link={link}
          linkMode={linkMode}
          toggleModal={toggleModal}
          standardVideoWidth={standardVideoWidth}
          videoPlay={videoPlay}
          playerComponent={PlayerComponent}
          moduleType={moduleType}
        />
      )}
      {videoPosition === VideoModulePositions.LEFT && (
        <LeftPosition
          thumbnail={thumbnail}
          poster={poster}
          title={title}
          titleSize={titleSize}
          text={text}
          link={link}
          linkMode={linkMode}
          toggleModal={toggleModal}
          standardVideoWidth={standardVideoWidth}
          videoPlay={videoPlay}
          playerComponent={PlayerComponent}
          linkPosition={linkPosition}
          moduleType={moduleType}
        />
      )}
      {videoPosition === VideoModulePositions.RIGHT && (
        <RightPosition
          thumbnail={thumbnail}
          poster={poster}
          title={title}
          titleSize={titleSize}
          text={text}
          link={link}
          linkMode={linkMode}
          toggleModal={toggleModal}
          standardVideoWidth={standardVideoWidth}
          videoPlay={videoPlay}
          playerComponent={PlayerComponent}
          linkPosition={linkPosition}
          moduleType={moduleType}
        />
      )}
      {modalOpened && (
        <VideoModal onClose={toggleModal}>
          <VideoPlayer
            source={videoSource}
            id={videoId}
            title={title}
            streamlyUrl={streamlyUrl}
          />
        </VideoModal>
      )}
    </Wrapper>
  );
};
